var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCriticalAssetOutlined16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Size=16, Type=Outlined, Color=Black, State=Enabled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 74 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.28185 2.70312C3.90393 2.70312 3.5583 2.91617 3.38848 3.25379L2.31117 5.39573H5.0836L6.42149 2.70312H4.28185ZM7.53813 2.70312L6.20024 5.39573H9.66525L8.40894 2.70312H7.53813ZM9.51243 2.70312L10.7687 5.39573H13.6976L12.6506 3.26251C12.4825 2.92011 12.1343 2.70312 11.7529 2.70312H9.51243ZM13.4399 6.39573H8.48901V12.4016L13.4399 6.39573ZM7.48901 12.3979V6.39573H2.55788L7.48901 12.3979ZM2.49512 2.80446C2.83474 2.12922 3.52601 1.70312 4.28185 1.70312H11.7529C12.5157 1.70312 13.2121 2.13709 13.5483 2.8219L14.9489 5.67542C15.0354 5.85168 15.0107 6.06226 14.8858 6.21377L8.37482 14.1122C8.27975 14.2276 8.13806 14.2943 7.98859 14.2942C7.83913 14.2941 7.69755 14.2271 7.60267 14.1116L1.11367 6.21313C0.988096 6.06028 0.96444 5.84778 1.05332 5.67106L2.49512 2.80446Z",
    fill: "#141414"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCriticalAssetOutlined16);
export default __webpack_public_path__ + "static/media/critical_asset_outlined_16.f806ecd6419828c7c9883cfecb4a8997.svg";
export { ForwardRef as ReactComponent };